import ReuseableTable from '../../table/ReuseableTable';
import { createRow, headerCells } from '../../../utils/table/automationsTable';
import {
  AutomationActionHandlers,
  AutomationListItem,
} from '../../../types/marketing/automations';

interface Props {
  automations: AutomationListItem[];
  isLoading: boolean;
  isError: boolean;
  handlers: AutomationActionHandlers;
  disableActions: boolean;
  highlightedAutomationId: string | null;
}

function AutomationsTable({
  automations,
  isLoading,
  isError,
  handlers,
  disableActions,
  highlightedAutomationId,
}: Props) {
  return (
    <ReuseableTable
      name="Active Automations"
      emptyMessage={
        isError
          ? "We couldn't load your automations. Refresh the page to try again."
          : 'No automations yet — turn on a recipe above to get started.'
      }
      headerCells={headerCells}
      loading={isLoading}
      rows={automations.map(automation =>
        createRow(automation, {
          handlers,
          disableActions,
          isHighlighted: automation.id === highlightedAutomationId,
        }),
      )}
    />
  );
}

export default AutomationsTable;
